import CALENDAR_CONFIG from '../config/calendarConfig';
import { calendarIntegrationService } from './calendarIntegrationService';
import { realCalendarIntegrationService } from './realCalendarIntegrationService';

/**
 * Single entry point for customer booking flows, business Settings, and calendar UI.
 * Honors `USE_REAL_CALENDAR_API` in calendarConfig.
 */
export const activeCalendarIntegrationService = CALENDAR_CONFIG.USE_REAL_CALENDAR_API
  ? realCalendarIntegrationService
  : calendarIntegrationService;
